<template functional>
  <div class="d-flex flex-direction-row">
    <span
      class="px-2 mb-2"
      v-for="item in props.row.sigatoka_config_bws"
      :key="item.id"
    >
      <div
        class="shadow-sm d-flex p-2 px-3"
        style="
          height: auto;
          color: black;
          width: auto;
          border: 1px solid #67c23a;
        "
        type="info"
      >
        <div class="pt-2">
          <div class="d-flex justify-content-between">
            <h6 class="mb-2">
              <strong><translate-text keyTranslate="sigatoka.leaf" />:</strong>
            </h6>
            {{ item.leaf }}
          </div>

          <div class="d-flex justify-content-between">
            <h6 class="mb-1">
              <strong
                ><translate-text keyTranslate="sigatoka.stages" />:</strong
              >
            </h6>
            <span>
              {{
                item.sigatoka_config_bw_statuses.map((s) => s.status).join(', ')
              }}
            </span>
          </div>

          <h6 class="mb-1 mt-2">
            <strong
              ><translate-text keyTranslate="sigatoka.gross_sum_values" /> (- /
              +):</strong
            >
          </h6>
          <div class="d-flex justify-content-around">
            <div
              v-for="value in item.sigatoka_config_bw_grosses"
              :key="value.id"
            >
              {{ value.minus || 0 }}/{{ value.plus || 0 }}
            </div>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>
<script>
export default {
  name: 'BwLeafFormatter',
};
</script>
